class integralEvaluationSrv {

  constructor($resource,SERVICE_URL_CONSTANT) {

// NOTIFICATIONS SERVICES
    var asignaturesDetails = $resource(SERVICE_URL_CONSTANT.rosario + '/asignature/getAsignaturesDetails',{},{
      getAsignaturesDetails :{
        method:'GET'
      }
    });

    var asignaturesSave = $resource(SERVICE_URL_CONSTANT.rosario + '/asignature/updateAssignationValue',{},{
      updateAssignationValue :{
        method:'POST'
      }
    });

    var getMandatoryData = $resource(SERVICE_URL_CONSTANT.rosario + '/asignature/getMandatoryAsignatures',{},{
      getMandatoryDataFlag :{
        method:'GET'
      }
    });

  var getGraphicAsignature = $resource(SERVICE_URL_CONSTANT.rosario + '/asignature/getGraphic',{},{
      getGraphic :{
        method:'GET'
      }
    });

    var getTotalPercentageOfEnteredData = $resource(SERVICE_URL_CONSTANT.rosario + '/asignature/getTotalPercentageOfEnteredData',{},{
      getTotal :{
        method:'GET'
      }
    });


// Services Declarations
    return {
      asignaturesDetails: asignaturesDetails,
      asignaturesSave:asignaturesSave,
      getMandatoryData:getMandatoryData,
      getGraphicAsignature:getGraphicAsignature,
      getTotalPercentageOfEnteredData:getTotalPercentageOfEnteredData
    }


  }

}

integralEvaluationSrv.$inject=['$resource','SERVICE_URL_CONSTANT']
export default  angular.module('services.integralEvaluationSrv', [])
.service('integralEvaluationSrv', integralEvaluationSrv)
.name;



// WEBPACK FOOTER //
// ./src/app/u-faculty/integralEvaluation/integralEvaluationSrv.js